// Shared shipping weight + fee rules (mirrored server-side in server.py _order_weight_g / _reception_fee)
export const WEIGHT_MODES = ["delivery", "shipping", "chronopost"];
export const DEFAULT_WEIGHTS = { cookie: 120, brownie: 100, cupcookie: 90, prepared_box: 800, packaging: 150 };

const catOf = (kind) => ({ product: "cookie", limited: "cookie", brownie: "brownie", cupcookie: "cupcookie", prepared_box: "prepared_box" }[kind]);

export function cartWeightG(cart, weights) {
  const w = { ...DEFAULT_WEIGHTS, ...(weights || {}) };
  let g = 0;
  let physical = false;
  for (const it of cart || []) {
    if (it.kind === "giftcard") continue;
    physical = true;
    let unit = 0;
    if (it.kind === "box") unit = (it.composition || []).reduce((s, c) => s + (Number(c.quantity) || 0) * (Number(w.cookie) || 0), 0);
    else unit = Number(w[catOf(it.kind)]) || 0;
    g += unit * (Number(it.quantity) || 1);
  }
  return physical ? Math.round(g + (Number(w.packaging) || 0)) : 0;
}

export function receptionFee(rec, mode, subtotal, weightG) {
  if (!rec) return 0;
  let fee = Number(rec.fee) || 0;
  const tiers = WEIGHT_MODES.includes(mode) ? (rec.weight_tiers || []).filter((t) => t && t.fee !== "" && t.fee != null) : [];
  if (tiers.length) {
    const kg = weightG / 1000;
    const sorted = [...tiers].sort((a, b) => (a.max_kg ?? Infinity) - (b.max_kg ?? Infinity));
    const tier = sorted.find((t) => t.max_kg == null || t.max_kg === "" || kg <= Number(t.max_kg)) || sorted[sorted.length - 1];
    fee = Number(tier.fee) || 0;
  }
  const thr = rec.free_threshold;
  const freeMax = rec.free_max_kg;
  const weightOk = freeMax == null || freeMax === "" || weightG / 1000 <= Number(freeMax);
  if (thr != null && thr !== "" && subtotal >= Number(thr) && weightOk) fee = 0;
  return Math.round(fee * 100) / 100;
}
